import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ItaStatus } from '../models/ita-status.model';

@Injectable({ providedIn: 'root' })
export class IsraeliTaxService {
  private apiUrl = `${environment.apiUrl}/israelitax`;

  constructor(private http: HttpClient) {}

  getStatus(): Observable<ItaStatus> {
    return this.http.get<ItaStatus>(`${this.apiUrl}/status`);
  }

  disconnect(): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/connection`);
  }

  /** Navigates the browser (full-page redirect) to the ITA authorize URL. */
  connect(): void {
    window.location.href = `${this.apiUrl}/connect`;
  }
}
